import { CurrencyPipe } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, TemplateRef, ViewChild } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { Store, createSelector } from "@ngrx/store";
import { DiscountTypes } from "graphql.generated";
import { isNil } from 'lodash';
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { LibModule } from "src/app/lib.ts/lib.module";
import { ResponsiveHelperService } from "src/app/services/responsive-helper.service";
import { SharedModule } from "src/app/shared/shared.module";

import { JobEventSelectComponent } from "../event-select/event-select.component";

import { selectJob } from "../job-tool.reducer";
import { JobMutateObjectComponent, Step } from "../mutate-object/mutate-object.component";
import { mutateObjectFeature } from "../mutate-object/mutate-object.feature";

import { JobMutateDiscountActions } from "./mutate-discount.actions";

//app-job-mutate-discount works only with create mode
//all update and delete functionality commented for now
@Component({
    selector: 'app-job-mutate-discount',
    standalone: true,
    imports: [
        SharedModule,
        LibModule,
        ReactiveFormsModule,
        FreyaCommonModule,
        JobEventSelectComponent,
        JobMutateObjectComponent,
    ],
    templateUrl: './mutate-discount.component.html',
    styleUrl: './mutate-discount.component.scss',
})

export class JobMutateDiscountComponent implements AfterViewInit {

  // Template Refs
  @ViewChild('name') nameRef: TemplateRef<any>;
  @ViewChild('amount') amountRef: TemplateRef<any>;
  @ViewChild('events') eventsRef: TemplateRef<any>;

  public templates: Record<string, TemplateRef<any>>;

  public actions = JobMutateDiscountActions;

  public discountTypes = [
    {
      label: '$ - Fixed',
      value: DiscountTypes.Amount,
    },
    {
      label: '% - Percentage',
      value: DiscountTypes.Percentage,
    },
  ];

  constructor(
    public responsiveHelper: ResponsiveHelperService,
    public store: Store,
    private currencyPipe: CurrencyPipe,
    private cd: ChangeDetectorRef,
    ) { }

  public viewModel$ = this.store.select(createSelector(
    mutateObjectFeature.selectMutateObjectDialog,
    selectJob,
    ({ mutators }, job ) => {

      const currency = job?.currency || 'USD';

      const {
        discountName,
        amount,
        eventIds,
        discountType,
        code,
      } = mutators.discount;

      const isPercentage = discountType === 'percentage';

      const steps: Step[] = [
        {
          name: 'Name',
          templateId: 'name',
          editable: true,
          reviewValue: discountName,
          invalid: !discountName?.trim(),
        },
        {
          name: 'Code',
          editable: false,
          reviewValue: code,
        },
        {
          name: 'Amount',
          templateId: 'amount',
          editable: true,
          reviewValue: amount && this.currencyPipe.transform(amount, currency),
          invalid: !discountType || isNil(amount) || amount < 0,
        },
        {
          name: 'Active',
          editable: false,
          reviewValue: 'Active',
        },
        {
          name: 'Starts At',
          editable: false,
          reviewValue: 'Today',
        },
        {
          name: 'Expires',
          editable: false,
          reviewValue: 'No Expiration Date',
        },
        {
          name: 'Events',
          templateId: 'events',
          editable: true,
          reviewValue: eventIds.length.toFixed(),
          invalid: !eventIds.length,
        },
      ];

      return {
        discountName,
        amount,
        eventIds,
        discountType,
        currency,
        steps,
        isPercentage,
      }
    }
  ));

  ngAfterViewInit(): void {
    this.templates = {
      name: this.nameRef,
      amount: this.amountRef,
      events: this.eventsRef,
    }

    this.cd.detectChanges();
  }

}
